// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__E6nlf","tab":"ProcedureTabs_tab__1k0n6"};